import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomDateFormatPipe } from '../../../../pipes/custom-date-format.pipe';
import { DataService } from '../../../../services/dashboard/data.service';

@Component({
  selector: 'app-card',
  imports: [CommonModule, CustomDateFormatPipe],
  templateUrl: './card.component.html',
  styleUrl: './card.component.css'
})
export class CardComponent {
  @Input() businessName: string = "";
  @Input() creationDate: string = "";
  @Input() activeSubstance: string = "";
  @Input() therapeuticArea: string = "";
  @Input() therapeuticIndication: string = "";
  @Input() reimbursementClass: string = "";
  @Input() supplyClass: string = "";
  @Input() atc: string = "";
  @Input() aic: string = "";
  @Input() openToAccessType: string = "";
  @Input() id: number = 0;

  @Output() infoClicked = new EventEmitter<void>();
  @Output() farmacoToDashboard = new EventEmitter<number>();

  constructor (private dataService: DataService) { }

  onInfoClick (event: MouseEvent) {
    event.stopPropagation();
    this.infoClicked.emit();
  }

  farmacoSelected () {
    /*   sessionStorage.setItem("activities","");*/
    this.dataService.setBusinessName(this.businessName);
    sessionStorage.setItem('openType', this.openToAccessType);
    this.dataService.emitMedicineUpdate(this.id);
    this.farmacoToDashboard.emit(this.id);
  }
}
